define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/form/Widget",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/state/rootStore",
	"csi/types",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, Widget, def, Field, Relationship, {sessionStore}, types, csiStore, Names, xml, Query) {

	return declare(Widget, {
		CONTACT: "Contact",

		ownerNodeType: null, // will be overwritten in SupplierReviewForm and FactoryReviewForm

		_resolveView: function() {
			// summary: form pre-processing
			this.parentFormNode = this.defView.m_formData.getParent();

			if (this.ownerNodeType && this.parentFormNode.$Type == "_CS_Data") {
				// TA30164: When creating Factory or Supplier Review under All Reviews view, allow selecting Factory/Supplier on the form
				var self = this;
				this.insertField(lang.mixin(new Field(), {
					m_label: this.ownerNodeType,
					m_id: xml.ATTR_PARENT,
					m_onChange: "_onChangeSupplierOrFactory",
					bForceEditable: true,
					m_bRequired: true,
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_relationship: lang.mixin(new Relationship(), {
						m_typeNode: self.ownerNodeType
					})
				}), 0);
			}

			this.addDefaultValue("Reviewer", sessionStore.currentUser.$URL);
			this.addDefaultValue("ReviewDate", types.getDateTime());

			if (this.isEdit()) {
				this.insertField(lang.mixin(new Field(), {
					m_label: "ORTemplate",
					m_id: "__Parent__",
					m_path: "Child:ORTemplateRevision"
				}), 0);
			}
			else {
				this.insertField(lang.mixin(new Field(), {
					m_id: "ORTemplateRevision",
					m_bRequired: true
				}), 0);
			}

			this.inherited(arguments);
		},

		/**
		 * Update the store for Contacts field on change of Supplier/Factory field
		 * @param {def.View} defView
		 * @param {Field} field
		 * @param {Any} value
		 */
		_onChangeSupplierOrFactory: function(defView, field, value) {
			const contactField = defView.getField("OwnerContact");
			this.setFieldValue(contactField, "");
		},
	});
});